import React, { useRef, useState } from 'react';
import { toast } from 'sonner';
import { api, authUrl } from '../../lib/api';
import { Check, Upload } from 'lucide-react';
import { Section } from './ProposalEditor';

const Thumb = ({ fid, selected, onClick, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`relative block w-full aspect-square overflow-hidden border-2 transition-colors ${selected ? 'border-stilo-gold' : 'border-transparent hover:border-stilo-stone'}`}>
    <img src={authUrl(`/files/${fid}`)} alt="" className="w-full h-full object-cover" />
    {selected && <span className="absolute top-1 right-1 bg-stilo-gold text-stilo-bg p-1"><Check className="w-3 h-3" /></span>}
  </button>
);

export const MoodboardEditor = ({ cid, url, setUrl, images, setImages, chatImages }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const toggle = (fid) => setImages(images.includes(fid) ? images.filter(x => x !== fid) : [...images, fid]);

  const onUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    try {
      const ids = [];
      for (const f of files) {
        const form = new FormData(); form.append('file', f);
        const r = await api.post(`/consultations/${cid}/proposal/images`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
        ids.push(r.data.file_id);
      }
      setImages([...images, ...ids]);
      toast.success('Imágenes añadidas al moodboard (recuerda guardar)');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Error al subir');
    } finally { setUploading(false); if (inputRef.current) inputRef.current.value = ''; }
  };

  const chatOnly = chatImages.filter(fid => !images.includes(fid));

  return (
    <Section title="Moodboard" testid="proposal-moodboard-section">
      <label className="block text-sm text-stilo-ink2 mb-2">Enlace a tu moodboard (APP Programa)</label>
      <input value={url} onChange={e => setUrl(e.target.value)} placeholder="https://…"
        className="w-full border border-stilo-ink/15 p-3 bg-stilo-bg focus:outline-none focus:border-stilo-ink" data-testid="proposal-moodboard-url" />

      <div className="flex items-center justify-between mt-8 mb-3">
        <p className="text-sm text-stilo-ink2">Imágenes del PDF ({images.length})</p>
        <button onClick={() => inputRef.current?.click()} disabled={uploading} className="inline-flex items-center gap-2 px-4 py-2 border border-stilo-ink/15 text-sm hover:border-stilo-ink disabled:opacity-50" data-testid="proposal-upload-images">
          <Upload className="w-4 h-4" strokeWidth={1.5} /> {uploading ? 'Subiendo…' : 'Subir imágenes'}
        </button>
        <input ref={inputRef} type="file" multiple accept="image/*" className="hidden" onChange={onUpload} />
      </div>
      {images.length === 0 && <p className="text-sm text-stilo-ink3">Aún no hay imágenes. Súbelas o elígelas de las fotos del chat.</p>}
      <div className="grid grid-cols-3 sm:grid-cols-5 gap-3">
        {images.map(fid => (
          <div key={fid}>
            <Thumb fid={fid} selected onClick={() => toggle(fid)} testid={`mood-selected-${fid}`} />
          </div>
        ))}
      </div>

      {chatOnly.length > 0 && (
        <>
          <p className="text-sm text-stilo-ink2 mt-8 mb-3">Fotos compartidas en el chat · pulsa para añadirlas</p>
          <div className="grid grid-cols-4 sm:grid-cols-6 gap-3">
            {chatOnly.map(fid => <Thumb key={fid} fid={fid} selected={false} onClick={() => toggle(fid)} testid={`mood-chat-${fid}`} />)}
          </div>
        </>
      )}
    </Section>
  );
};
